import React from 'react';
import { Operation, OperationContextType } from '../../../services/types/Operation';

const Context = React.createContext<OperationContextType>({
  operation: {} as Operation,
  loading: false,
  reload: () => {},
});

export default Context;
